import { render } from "./wechatFeedback.vue?vue&type=template&id=4e869c22&scoped=true"
import script from "./wechatFeedback.vue?vue&type=script&lang=js"
export * from "./wechatFeedback.vue?vue&type=script&lang=js"

import "./wechatFeedback.vue?vue&type=style&index=0&id=4e869c22&scoped=true&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e869c22"]])

export default __exports__